import { hoc } from '#packages/util';
import React from 'react';
import { Box, Text, TextButton } from '@wix/design-system';
import {
  mapDispatchToProps,
  type UndoTooltipMapDispatchToProps,
} from './undoTooltipMapper';
import styles from './tooltip.scss';
import { t } from '#packages/i18n';

const UndoButtonTooltipPure = ({
  onTooltipCtaClick,
}: UndoTooltipMapDispatchToProps) => {
  return (
    <Box
      direction="vertical"
      dataHook="top-bar-undo-button-site-history-tooltip"
      padding="18px"
    >
      <div className={styles.tooltipParagraph}>
        <Text size="small" weight="thin" ellipsis={false} secondary>
          {t('TOPBAR_UNDO_DISABLED_TOOLTIP_TEXT')}
        </Text>
      </div>
      <TextButton
        dataHook="top-bar-undo-button-tooltip-site-history-link"
        size="small"
        onClick={onTooltipCtaClick}
      >
        {t('TOPBAR_UNDO_DISABLED_TOOLTIP_CTA')}
      </TextButton>
    </Box>
  );
};

export const UndoButtonTooltip = hoc.connect(
  hoc.STORES.EDITOR_API,
  null,
  mapDispatchToProps,
)(UndoButtonTooltipPure);
